import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; // For loading translations
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // load translations using http (public/locales/en/translation.json)
  .use(Backend) 
  // detect user language
  .use(LanguageDetector)
  // passes i18n instance to react-i18next
  .use(initReactI18next) 
  .init({
    fallbackLng: 'en', // default language if the detected language is not available
    debug: true,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // The default namespace is 'translation'
    ns: ['common', 'home'], 
    defaultNS: 'common',
  });

export default i18n;